"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.amountForFeeCap = void 0;
const enums_1 = require("./types/enums");
const utils_1 = require("./utils");
const feeStructure_1 = require("./calculateFees/feeStructure");
const calculateCappedFeeAmount = (params) => {
    // No Deed fees are charged
    const { fixed, relative } = (0, feeStructure_1.feeStructure)(params);
    const { feeAmountCap } = params;
    return (feeAmountCap - fixed) / (relative / 100);
};
const UNCAPPED_FEE_AMOUNT = Number.POSITIVE_INFINITY;
/**
 * Per [sc-48978]:
 * For providers where no Deed fees are charged (e.g. GG, NFG, GI):
 *   - Limit donation maximum, so that fee rate corresponds to $250 fee maximum
 * For providers where Deed fees are charged (e.g. PP, Stripe):
 *   - Cap Deed application fee to $250
 *   - Keep payment processor fee uncapped
 * For CAF provider, Deed fees are uncapped
 *   - Deed application fee uncapped
 *   - Keep payment processor fee uncapped
 */
const amountForFeeCap = (params) => {
    const { donationProvider } = params;
    switch (donationProvider) {
        case enums_1.DonationProvider.NFG:
        case enums_1.DonationProvider.GiveIndia:
        case enums_1.DonationProvider.GlobalGiving:
            return calculateCappedFeeAmount(params);
        case enums_1.DonationProvider.PayPal:
        case enums_1.DonationProvider.Stripe:
        case enums_1.DonationProvider.CAF:
        case enums_1.DonationProvider.Give2Asia:
            return UNCAPPED_FEE_AMOUNT;
        default:
            // Other providers (Betterplace and External) should not be used with calculateFees or amountForFeeCap
            (0, utils_1.isNever)(donationProvider);
            throw new Error(`Donation provider ${donationProvider} is not supported for fee caps`);
    }
};
exports.amountForFeeCap = amountForFeeCap;
//# sourceMappingURL=amountForFeeCap.js.map